import { Children, ReactElement, useState } from "react";
import { useHistory } from "react-router-dom";

import { IPageRootProps } from "./Page.types";
import {
  IconButton,
  Container,
  ArrowBack,
  Heading,
  Header,
  Flex,
  Tabs,
  Tab,
} from "./Page.styled";

import HeaderNavigation from "components/header";

export function PageRoot({ title, backRoute, children }: IPageRootProps) {
  const [currentTab, setCurrentTab] = useState(0);
  const history = useHistory();

  const validChildren = Children.toArray(children) as ReactElement[];

  function handleChangeTab(tabId: number) {
    setCurrentTab(tabId);
  }

  return (
    <Container>
      <Header>
        <HeaderNavigation />
        <Flex>
          {backRoute && (
            <IconButton onClick={() => history.push(backRoute)}>
              <ArrowBack color="primary" />
            </IconButton>
          )}
          <Heading>{title}</Heading>
        </Flex>
        <Flex>
          {validChildren.length > 1 && (
            <Tabs value={currentTab} onChange={(_, e) => handleChangeTab(e)}>
              {validChildren.map((child, index) => (
                <Tab
                  key={index}
                  label={child.props.name}
                  value={index}
                  disabled={child.props.disabled}
                />
              ))}
            </Tabs>
          )}
          {/* {!Array.isArray(children) && (
            <Tabs value={currentTab}>
              <Tab
                label={children.props.name}
                value={0}
                disabled={children.props.disabled}
              />
            </Tabs>
          )} */}
        </Flex>
      </Header>
      {validChildren.length > 1 ? validChildren[currentTab] : validChildren[0]}
    </Container>
  );
}
